/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListAiModelCardsParams,
  PaginatedAiModelCards,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of AI Model Cards
 */
export const listAiModelCards = (
    params?: MaybeRefOrGetter<ListAiModelCardsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiModelCards>(
      {url: `/ai/model_cards`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiModelCardsQueryKey = (params?: MaybeRefOrGetter<ListAiModelCardsParams>,) => {
    return [
    'ai','model_cards', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiModelCardsQueryOptions = <TData = Awaited<ReturnType<typeof listAiModelCards>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListAiModelCardsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiModelCards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiModelCardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiModelCards>>> = ({ signal }) => listAiModelCards(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiModelCards>>, TError, TData>
}

export type ListAiModelCardsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiModelCards>>>
export type ListAiModelCardsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of AI Model Cards
 */

export function useListAiModelCards<TData = Awaited<ReturnType<typeof listAiModelCards>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListAiModelCardsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiModelCards>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiModelCardsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






